import { useTheme } from "@emotion/react";
import { MdArrowDownward, MdArrowUpward } from "react-icons/md";

import { CustomerAnalyticsSort, CustomerAnalyticsSortField } from "@megaron/crm-contracts";

type Props = {
  sortFieldName: CustomerAnalyticsSortField;
  activeSortValue: CustomerAnalyticsSort | undefined;
  onSortChange: (value: CustomerAnalyticsSort | undefined) => void;
  label: string;
  aggName: string | null;
  customColumn?: string;
  onRightClick: (e: React.MouseEvent) => void;
};

export const SortableTableHeadingCell = ({
  label,
  sortFieldName,
  activeSortValue,
  onSortChange,
  aggName,
  customColumn,
  onRightClick,
}: Props) => {
  const theme = useTheme();

  const isSortActive = sortFieldName
    ? activeSortValue?.fieldName === sortFieldName && activeSortValue.agg === aggName
    : false;

  const getOrder = (activeOrder: "ASC" | "DESC" | undefined) => {
    if (activeOrder === "ASC") {
      return "DESC";
    }

    if (activeOrder === "DESC") {
      return undefined;
    }

    return "ASC";
  };

  const activeOrder = isSortActive ? activeSortValue?.order : undefined;

  const handleClick = () => {
    const newOrder = getOrder(activeOrder);

    onSortChange(
      newOrder === undefined
        ? undefined
        : { agg: aggName, fieldName: sortFieldName, order: newOrder, customColumn: customColumn ?? null },
    );
  };

  return (
    <button
      key={label}
      css={{
        background: theme.colors.primaryLight,
        color: theme.colors.primary,
        padding: "0.5rem 0.75rem",
        fontFamily: theme.displayFontFamily,
        fontWeight: 400,
        fontSize: "0.9375rem",
        width: "100%",
        textAlign: "left",
        border: "none",
        display: "flex",
        alignItems: "center",
        gap: "0.25rem",
        whiteSpace: "nowrap",
        cursor: "pointer",
        borderTopLeftRadius: theme.extraSmallBorderRadius,
        borderTopRightRadius: theme.extraSmallBorderRadius,
      }}
      onContextMenu={(e) => onRightClick(e)}
      onClick={handleClick}
    >
      {label}
      {activeOrder === "ASC" && <MdArrowUpward size={14} />}
      {activeOrder === "DESC" && <MdArrowDownward size={14} />}
    </button>
  );
};
